export default __webpack_public_path__ + "static/media/message.960ad464.svg";